export const PRODUCT_FILTERS = {
  status: ['draft', 'created', 'published', 'archived'],
  brand: ['casanoov', 'cazeboo', 'sicaan'],
  type: [
    { value: 'standalone', label: 'Stand Alone' },
    { value: 'kit', label: 'Kit' },
    { value: 'pack', label: 'Pack' },
  ],
  published: [true, false],
};

export const STRUCTURED_DATA_FIELDS = (productDetails) => {
  // Parse composition if it's a string
  const parseComposition = (composition) => {
    if (typeof composition === 'string') {
      try {
        return JSON.parse(composition.replace(/'/g, '"'));
      } catch {
        return composition;
      }
    }
    return composition;
  };

  const compositionData = parseComposition(productDetails.composition);
  const compositionDisplay =
    typeof compositionData === 'object'
      ? Object.entries(compositionData)
          .map(([key, value]) => `${key}: ${value}`)
          .join(', ')
      : compositionData;

  return [
    {
      key: 'reference',
      label: 'Référence',
      value: productDetails.reference || '',
      description: 'Référence unique du produit',
    },
    {
      key: 'name',
      label: 'Nom',
      value: productDetails.name || '',
      description: 'Nom commercial du produit',
    },
    {
      key: 'category',
      label: 'Catégorie',
      value: productDetails.category?.name || '',
      description: 'Catégorie à laquelle appartient le produit',
    },
    {
      key: 'type',
      label: 'Type',
      value: productDetails.type || '',
      description: 'Type de produit',
    },
    {
      key: 'slug',
      label: 'Slug',
      value: productDetails.slug || '',
      description: 'Identifiant URL du produit',
    },
    {
      key: 'pack_main_product',
      label: 'Produit principal du pack',
      value: productDetails.pack_main_product || '',
      description: "Produit principal si ce produit fait partie d'un pack",
    },
    {
      key: 'composition',
      label: 'Composition',
      value: compositionDisplay || '',
      description: 'Composition détaillée du produit',
    },
    {
      key: 'main_image',
      label: 'Image principale',
      value: productDetails.main_image || '',
      description: "URL de l'image principale du produit",
    },
    {
      key: 'width',
      label: 'Largeur',
      value: productDetails.width || '',
      description: 'Largeur du produit en centimètres',
      suffix: 'cm',
    },
    {
      key: 'length',
      label: 'Longueur',
      value: productDetails.length || '',
      description: 'Longueur du produit en centimètres',
      suffix: 'cm',
    },
    {
      key: 'height',
      label: 'Hauteur',
      value: productDetails.height || '',
      description: 'Hauteur du produit en centimètres',
      suffix: 'cm',
    },
    {
      key: 'package_length',
      label: 'Longueur du colis',
      value: productDetails.package_length || '',
      description: 'Longueur du plus gros colis en centimètres',
      suffix: 'cm',
    },
    {
      key: 'package_width',
      label: 'Largeur du colis',
      value: productDetails.package_width || '',
      description: 'Largeur du plus gros colis en centimètres',
      suffix: 'cm',
    },
    {
      key: 'package_height',
      label: 'Hauteur du colis',
      value: productDetails.package_height || '',
      description: 'Hauteur du plus gros colis en centimètres',
      suffix: 'cm',
    },
    {
      key: 'raw_weight',
      label: 'Poids brut',
      value: productDetails.raw_weight || '',
      description: 'Poids brut du produit en kilogrammes',
      suffix: 'kg',
    },
    {
      key: 'net_weight',
      label: 'Poids net',
      value: productDetails.net_weight || '',
      description: 'Poids net du produit en kilogrammes',
      suffix: 'kg',
    },
    {
      key: 'package_type',
      label: "Type d'emballage",
      value: productDetails.package_type || '',
      description: "Type d'emballage utilisé pour le produit",
    },
    {
      key: 'number_of_packages',
      label: "Nombre d'emballages",
      value: productDetails.number_of_packages || '',
      description: "Nombre d'emballages nécessaires",
    },
    {
      key: 'ean13',
      label: 'Code EAN13',
      value: productDetails.ean13 || '',
      description: 'Code-barres EAN13 du produit',
    },
    {
      key: 'brand',
      label: 'Marque',
      value: productDetails.brand || '',
      description: 'Marque du produit',
    },
    {
      key: 'range',
      label: 'Gamme',
      value: productDetails.range || '',
      description: 'Gamme à laquelle appartient le produit',
    },
    {
      key: 'main_material',
      label: 'Matériau principal',
      value: productDetails.main_material || '',
      description: 'Matériau principal utilisé dans la fabrication',
    },
    {
      key: 'warranty_time',
      label: 'Durée de garantie',
      value: productDetails.warranty_time || '',
      description: 'Durée de garantie en mois',
      suffix: 'mois',
    },
    {
      key: 'is_pack',
      label: 'Est un pack',
      value: productDetails.is_pack ? 'Oui' : 'Non',
      description: 'Indique si le produit est un pack ou non',
    },
  ];
};

export const PRODUCT_ATTRIBUTES = {
  technical: [
    {
      key: 'assembly_frame_type',
      label: "Type de cadre d'assemblage",
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      value: 'Cadre en aluminium',
    },
    {
      key: 'assembly_instruction_has',
      label: 'Notice incluse',
      description:
        'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      value: 'Oui',
    },
    {
      key: 'assembly_people_needed',
      label: 'Personnes nécessaires',
      description:
        'Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
      value: '2 personnes',
    },
    {
      key: 'assembly_time',
      label: "Temps d'assemblage",
      description: 'Duis aute irure dolor in reprehenderit in voluptate velit.',
      value: '45 minutes',
    },
    {
      key: 'assembly_type',
      label: "Type d'assemblage",
      description:
        'Excepteur sint occaecat cupidatat non proident sunt in culpa.',
      value: 'Vissage',
    },
    {
      key: 'blade_color',
      label: 'Couleur des lames',
      description:
        'Nulla pariatur excepteur sint occaecat cupidatat non proident.',
      value: 'Brun naturel',
    },
    {
      key: 'blade_material',
      label: 'Matériau lame',
      description:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem.',
      value: 'Bois composite',
    },
    {
      key: 'blade_number',
      label: 'Nombre de lames',
      description:
        'Accusantium doloremque laudantium totam rem aperiam eaque ipsa.',
      value: '12',
    },
    {
      key: 'blade_thickness',
      label: 'Épaisseur lame',
      description:
        'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet.',
      value: '15 mm',
    },
    {
      key: 'canvas_has',
      label: 'Toile incluse',
      description:
        'Consectetur adipisci velit sed quia non numquam eius modi tempora.',
      value: 'Non',
    },
    {
      key: 'color_structure',
      label: 'Couleur structure',
      description:
        'Incidunt ut labore et dolore magnam aliquam quaerat voluptatem.',
      value: 'Anthracite',
    },
    {
      key: 'frame_material',
      label: 'Matériau cadre',
      description:
        'Ut enim ad minima veniam quis nostrum exercitationem ullam corporis.',
      value: 'Aluminium thermolaqué',
    },
    {
      key: 'frame_height',
      label: 'Hauteur cadre',
      description:
        'Suscipit laboriosam nisi ut aliquid ex ea commodi consequatur.',
      value: '180 cm',
    },
    {
      key: 'frame_width',
      label: 'Largeur cadre',
      description:
        'Quis autem vel eum iure reprehenderit qui in ea voluptate velit.',
      value: '200 cm',
    },
    {
      key: 'lock_has',
      label: 'Serrure incluse',
      description:
        'Esse quam nihil molestiae consequatur vel illum qui dolorem eum.',
      value: 'Oui',
    },
    {
      key: 'lock_type',
      label: 'Type de serrure',
      description:
        'Fugiat quo voluptas nulla pariatur at vero eos et accusamus.',
      value: 'Serrure à clé',
    },
    {
      key: 'product_height',
      label: 'Hauteur',
      description:
        'Et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum.',
      value: '185 cm',
    },
    {
      key: 'product_width',
      label: 'Largeur',
      description:
        'Deleniti atque corrupti quos dolores et quas molestias excepturi.',
      value: '205 cm',
    },
    {
      key: 'product_weight_net',
      label: 'Poids net',
      description:
        'Sint occaecati cupiditate non provident similique sunt in culpa.',
      value: '25 kg',
    },
    {
      key: 'wind_resistance',
      label: 'Résistance au vent',
      description:
        'Qui officia deserunt mollit anim id est laborum et dolorum fuga.',
      value: '80 km/h',
    },
  ],
  marketing: ['placeholder', 'placeholder', 'placeholder', 'placeholder'],
};
